import { FC } from 'react';
import { ButtonComponent } from '../UI/ButtonComponent/ButtonComponent';
import './WarningFormOverlayComponent.scss';
import { IErrorsObject } from '../forms/BrandForms/model';
interface WarningOverLayComponentProps {
	closeOverlay: () => void;
	updateData: () => void;
	cancelUpdate: () => void;
	isValidForm: boolean;
	formErrors?: IErrorsObject | null;
}
export const WarningFormOverlayComponent: FC<WarningOverLayComponentProps> = ({
	cancelUpdate,
	closeOverlay,
	updateData,
	isValidForm,
	formErrors
}) => {
	const handleContainerClick = (e: { stopPropagation: () => void }) => {
		e.stopPropagation();
	};

	return (
		<div className='warning-overlay-container' onClick={handleContainerClick}>
			<div className='warning-title-container'>
				<p>Save Your Changes?</p>
				<ButtonComponent
					onClick={closeOverlay}
					style='rounded-button tertiary menu-button'
					text=''
					icon={<i className='ri-close-line'></i>}
					iconOnly
				/>
			</div>
			<div className='warning-body-container'>
				<div className='warning-description-container'>
					<p className='description-title'>You are currently editing another section.</p>
					<p className='description-body'>
						{formErrors! !== null && formErrors!.totalErrors > 0
							? 'To save your changes and edit another section, please fix the following errors:'
							: 'Do you want to save your changes before editing the next section?'}
					</p>
					{formErrors! !== null && (
						<ul className='list-errors'>
							{formErrors!.errors?.map((item, index) => (
								<li key={index}>{`'${item.fieldName}' ${item.errorString}`}</li>
							))}
							{formErrors!.totalErrors > 5 && <li>And additional errors for this section.</li>}
						</ul>
					)}
				</div>
				<div className='warning-buttons-container'>
					<ButtonComponent
						style='rounded-button secondary'
						text='Undo Changes'
						onClick={() => {
							cancelUpdate();
							closeOverlay();
						}}
					/>
					{formErrors !== null ? (
						<ButtonComponent
							style='rounded-button primary'
							text='Continue Editing'
							onClick={closeOverlay}
						/>
					) : (
						<ButtonComponent
							style='rounded-button primary'
							text='Save Changes For This Section'
							onClick={() => {
								updateData();
								closeOverlay();
							}}
							disabled={!isValidForm}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
